import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSurfaceDetectionManueel = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "100%",
	height: "100%",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(1,0,0,1,-1.010552,0.95639)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12,3L12,21",
				style: {
					fill: "none",
					fillRule: "nonzero",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.836,14.229L17.243,22.48L19.044,19.475L22.655,18.124L14.836,14.228L14.836,14.229Z",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.38px"
			}
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.884072,0,0,1,2.317336,-0)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M16.721,12.956L19.989,12.956",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.936115,0,0,1,0.127096,0)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M1.989,12.956L13.377,12.956",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "matrix(0.006137,0.999981,-0.999981,0.006137,22.915584,0.882978)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M21.005,8.826L21,19C21,20.104 20.104,21 19,21L5,21C3.896,21 3,20.104 3,19L3,5C3,3.896 3.896,3 5,3L12.612,3",
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: "1.5px"
				}
			})
		})
	] })
});
export default SvgSurfaceDetectionManueel;
